const PhoneMaskConfig = Object.freeze({
  us: '(###) ###-####',
  au: '## #### ####',
  ca: '(###) ###-####',
  jp: '#'.repeat(11),
  nl: '### ### ####',
  gb: '##### ######',
  kr: '###-####-####',
  de: '#'.repeat(13),
  at: '#'.repeat(13),
  usb2b: '(###) ###-####',
  fallback: '#'.repeat(15),
});

const getPhoneMaskPattern = (locale) => {
  return PhoneMaskConfig[locale] ?? PhoneMaskConfig.fallback;
};

const getFormattedPhoneNumber = (number, locale) => {
  let i = 0;
  const unformatPhoneValue = ('' + number).replace(/\D/g, '');
  return getPhoneMaskPattern(locale).replace(/#/g, () => {
    if (unformatPhoneValue[i] === undefined) return '';
    return unformatPhoneValue[i++];
  });
};

export {getPhoneMaskPattern, getFormattedPhoneNumber};
